import { Navigate, Outlet, useRoutes } from "react-router-dom";
import PayoutRunHistory from "./components/PayoutHistory/PayoutRunHistory";
import PayoutRunDetail from "./components/PayoutHistory/PayoutRunDetail";
// layouts
import DashboardLayout from "./layouts/dashboard";
import RequireAccess from "./layouts/dashboard/RequireAccess";
import { FEATURE } from "./util/enums";
//
import Login from "./pages/Login";
// import SignupContainer from "./components/authentication/SignupContainer";
// import SignupStep2 from "./components/authentication/SignupStep2";
// import SignupStep3 from "./components/authentication/SignupStep3";
// import SignupStep4 from "./components/authentication/SignupStep4";
// import SignupStep5 from "./components/authentication/SignupStep5";
import DashboardAppNew from "./pages/DashboardAppNew";
import Products from "./pages/Products";
import Blog from "./pages/Blog";
import Users from "./pages/User";
import NotFound from "./pages/Page404";
import ChargerList from "./components/charger/ChargerList";
import { Charger } from "./components/charger/Charger";
import { TeamList } from "./components/Team/TeamList";
import UserList from "./components/user/UserList";
import User from "./components/user/User";
import { MainLayout } from "./layouts/MainLayout";
import { TransactionsList } from "./components/Transactions/TransactionsList/TransactionsList";
import { TransactionView } from "./components/Transactions/TransactionView";
import { TagList } from "./components/AuthCode/TagList";
import { Tag } from "./components/AuthCode/Tag";
import { PriceGroupList } from "./components/PriceGroup/PriceGroupList";
import { PriceGroup } from "./components/PriceGroup/PriceGroup";
import { Team } from "./components/Team/Team";
import { CustomerList, Customer } from "./components/customer";
import {
  CustomerOnboardingForm,
  CustomerOnboardingList,
} from "src/components/customer/customer-onboarding";

// Reset Password
import { ResetPassword } from "./components/authentication/ResetPassword";
import ChangePassword from "./components/ChangePassword";
// My Profile
import Profile from "./pages/Profile";
import { Company } from "./components/company/Company";
import { RoleList } from "./components/roles/RoleList";
import { Role } from "./components/roles/Role";
import { CompanyList } from "./components/company/CompanyList";
import ServiceRequestView from "./components/ServiceRequest/ServiceRequestView";
import ServiceRequestFormView from "./components/ServiceRequest/SeviceRequestForm/ServiceRequestFormView";
import ChargingProfileView from "./components/charger/ChargingProfile/ChargingProfileView";
import ChargingProfileFormView from "./components/charger/ChargingProfile/ChargingProfileForms/ChargingProfileFormView";

//refund
import Refund from "./components/Refund";
import CMCustomerList from "./components/cmCustomer/CMCustomerList";
import EmailVerification from "./pages/EmailVerification";
import Register from "./pages/Register";
import ReportTabList from "./components/reportTab/ReportTabList";
import ChargeZone from "./components/chargeZone/ChargeZone";
import ServiceRequestComment from "./components/ServiceRequest/ServiceRequestComment";
import Members from "./pages/Members";
import OCPITokens from "./pages/ocpi-tokens";
import OCPICommands from "./pages/ocpi-commands";
import OCPISessions from "./pages/ocpi-sessions";
import OCPIManagement from "./pages/OCPIManagement";
import OCPIDashboard from "./pages/OCPIDashboard";
import OCPITariffs from "./pages/ocpi-tariffs";
import OCPIAnalytics from "./pages/ocpi-analytics";
import OCPILocationsPage from "./pages/ocpi-locations";

import MembersManagement from "./components/Members/MembersManagement";
import CMCustomerWalletTransactionHistory from "./components/cmCustomer/CMCustomerWalletTransactionHistory";
import RFIDUsageReports from "./pages/RFIDUsageReports";
import AddRFIDTagFormPage from "./pages/AddRFIDTagFormPage";
import MapComponent from "./components/map";
import ProductListing from "./components/product";
import ProductForm from "./components/product/ProductForm";
import ZynkaStuite from "./components/ZynkaSuite";
import ThirdParty from "./components/ThirdParty";
import OCPI from "./components/ocpi";
import OcpiOnboardingWizard from "./components/ocpi/onboarding/OcpiOnboardingWizard";
import Partner from "./components/ocpi/partners/Partner";
import ManagePromoCodes from "./components/ManagePromoCodes";
import FleetDashboard from "./components/fleet/FleetDashboard";
import MobileCpoOnboarding from "./components/mobileOnboarding/MobileCpoOnboarding";
import FleetOperatorForm from "./components/fleet/FleetOperatorForm";
import FleetOperatorDetail from "./components/fleet/FleetOperatorDetail";
import PromoCodesAnalytics from "./components/ManagePromoCodes/PromoCodeAnalytics";
import PaymentCompletion from "./pages/PaymentCompletion";
import PaymentFailed from "./pages/PaymentFailed";
import Signup from "./pages/signup/Signup";
import PlanCheckoutFlow from "./pages/subscription/PlanCheckoutFlow";
import OnboardingPaymentStatus from "./pages/subscription/OnboardingPaymentStatus";
import PaymentCancelled from "./pages/signup/PaymentCancelled";


export default function Router({ isLoggedIn }) {
  return useRoutes([
    {
      path: "/",
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: "", element: <Navigate to="/dashboard" /> },
        {
          path: "payout-history",
          element: <Outlet />,
          children: [
            { path: "", element: <PayoutRunHistory /> },
            { path: ":logId", element: <PayoutRunDetail /> },
          ],
        },
        {
          path: "dashboard",
          element: <Outlet />,
          children: [
            // { path: "", element: <DashboardApp /> },
            {
              path: "",
              element: (
                <RequireAccess featureName={FEATURE.DASHBOARD}>
                  <DashboardAppNew />
                </RequireAccess>
              ),
            },
            { path: "user", element: <Users /> },
            { path: "products", element: <Products /> },
            { path: "blog", element: <Blog /> },
          ],
        },
        {
          path: "charger",
          element: <Outlet />,
          children: [
            { path: "", element: <ChargerList /> },
            { path: "new", element: <Charger /> },
            { path: ":id", element: <Charger /> },
          ],
        },
        {
          path: "chargingprofile",
          element: <Outlet />,
          children: [
            { path: "", element: <ChargingProfileView /> },
            { path: "new", element: <ChargingProfileFormView /> },
            {
              path: ":chargingProfileId",
              element: <ChargingProfileFormView />,
            },
          ],
        },
        {
          path: "team",
          element: <Outlet />,
          children: [
            { path: "", element: <TeamList /> },
            { path: "new", element: <Team /> },
            { path: ":id", element: <Team /> },
          ],
        },
        {
          path: "users",
          element: <Outlet />,
          children: [
            { path: "", element: <UserList /> },
            { path: "new", element: <User /> },
            { path: ":id", element: <User /> },
          ],
        },
        {
          path: "transactions",
          element: <Outlet />,
          children: [
            { path: "", element: <TransactionsList /> },
            { path: ":id", element: <TransactionView /> },
          ],
        },
        {
          path: "tag",
          element: <Outlet />,
          children: [
            { path: "", element: <TagList /> },
            { path: "new", element: <AddRFIDTagFormPage /> },
            { path: ":tagId", element: <Tag /> },
          ],
        },
        {
          path: "pricegroup",
          element: <Outlet />,
          children: [
            { path: "", element: <PriceGroupList /> },
            { path: "new", element: <PriceGroup /> },
            { path: ":priceGroupId", element: <PriceGroup /> },
          ],
        },
        {
          path: "profile",
          element: <Outlet />,
          children: [{ path: "", element: <Profile /> }],
        },
        {
          path: "customer",
          element: <Outlet />,
          children: [
            { path: "", element: <CustomerList /> },
            { path: "new", element: <Customer /> },
            { path: ":id", element: <Customer /> },
          ],
        },
        {
          path: "changepassword",
          element: <ChangePassword />,
        },
        {
          path: "customer-onboarding",
          element: <Outlet />,
          children: [
            { path: "", element: <CustomerOnboardingList /> },
            { path: "new", element: <CustomerOnboardingForm /> },
          ],
        },

        {
          path: "company",
          element: <Outlet />,
          children: [
            { path: "", element: <CompanyList /> },
            { path: "new", element: <Company /> },
            { path: ":companyId", element: <Company /> },
          ],
        },
        {
          path: "servicerequest",
          element: <Outlet />,
          children: [
            { path: "", element: <ServiceRequestView /> },
            { path: "new", element: <ServiceRequestFormView /> },
            { path: ":ticketId", element: <ServiceRequestComment /> },
          ],
        },
        {
          path: "roles",
          element: <Outlet />,
          children: [
            { path: "", element: <RoleList /> },
            { path: "new", element: <Role /> },
            { path: ":roleId", element: <Role /> },
          ],
        },
        {
          path: "refund",
          element: <Outlet />,
          children: [
            { path: "", element: <Refund /> },
            { path: ":id", element: <TransactionView /> },
          ],
        },
        {
          path: "cm-customer",
          element: <Outlet />,
          children: [
            { path: "", element: <CMCustomerList /> },
            {
              path: ":id/company/:companyId",
              element: <CMCustomerWalletTransactionHistory />,
            },
          ],
        },
        {
          path: "report",
          element: <Outlet />,
          children: [{ path: "", element: <ReportTabList /> }],
        },
        {
          path: "charge-zone",
          element: <Outlet />,
          children: [{ path: "", element: <ChargeZone /> }],
        },
        {
          path: "management",
          element: <Outlet />,
          children: [
            { path: "", element: <Members /> },
            { path: "account-management/:id", element: <MembersManagement /> },
          ],
        },
        //previous one
        // {
        //   path: "rfid-usage-reports",
        //   element: <RFIDUsageReports />,
        //   path: "map",
        //   element: <Outlet />,
        //   children: [
        //     { path: "", element: <MapComponent /> },
        //   ],
        // },
        {
          path: "rfid-usage-reports",
          element: <RFIDUsageReports />,
        },
        {
          path: "map",
          element: <Outlet />,
          children: [{ path: "", element: <MapComponent /> }],
        },
        {
          path: "product-listing",
          element: <Outlet />,
          children: [
            { path: "", element: <ProductListing /> },
            { path: "new", element: <ProductForm /> },
            { path: ":id", element: <ProductForm /> },
          ],
        },
        {
          path: "zynka-suite",
          element: <Outlet />,
          children: [{ path: "", element: <ZynkaStuite /> }],
        },
        {
          path: "third-party",
          element: <Outlet />,
          children: [{ path: "", element: <ThirdParty /> }],
        },
        {
          path: "ocpi",
          element: <Outlet />,
          children: [
            { path: "partners", element: <OCPI /> },
            { path: "partners/onboard", element: <OcpiOnboardingWizard /> },
            { path: "partners/onboard/:id", element: <OcpiOnboardingWizard /> },
            { path: "partner/:id", element: <Partner /> },
            {
              path: "management",
              element: <OCPIManagement />,
            },
            {
              path: "dashboard",
              element: <OCPIDashboard />,
            },
            {
              path: "module/tokens",
              element: <OCPITokens />,
            },
            {
              path: "module/commands",
              element: <OCPICommands />,
            },
            {
              path: "module/sessions",
              element: <OCPISessions />,
            },
            {
              path: "module/tariffs",
              element: <OCPITariffs />,
            },
            {
              path: "analytics",
              element: <OCPIAnalytics />,
            },
            {
              path: "locations",
              element: <OCPILocationsPage />,
            },
          ],
        },
        {
          path: "manage-promo-codes",
          element: <Outlet />,
          children: [
            { path: "", element: <ManagePromoCodes /> },
            { path: "analytics", element: <PromoCodesAnalytics /> },
          ],
        },
        {
          path: "fleet",
          element: <Outlet />,
          children: [
            { path: "", element: <FleetDashboard /> },
            { path: "operators", element: <Navigate to="/fleet" replace /> },
            { path: "operators/new", element: <FleetOperatorForm /> },
            { path: "operators/:id", element: <FleetOperatorDetail /> },
            { path: "operators/:id/edit", element: <FleetOperatorForm /> },
          ],
        },
        {
          path: "mobile-cpo-onboarding",
          element: <Outlet />,
          children: [{ path: "", element: <MobileCpoOnboarding /> }],
        },
        { path: "payment-completion", element: <PaymentCompletion /> },
        { path: "payment-failed", element: <PaymentFailed /> },
      ],
    },
    {
      path: "/",
      element: !isLoggedIn ? <MainLayout /> : <Navigate to="/dashboard" />,
      children: [
        { path: "", element: <Navigate to="/login" replace /> },
        { path: "login", element: <Login /> },
        { path: "register", element: <Register /> },
        { path: "email-verification", element: <EmailVerification /> },
        { path: "reset", element: <ResetPassword /> },
        { path: "pagenotfound", element: <NotFound /> },
        { path: "signup", element: <Signup /> },
        {path: "subscription",element: <PlanCheckoutFlow />},
        {path: "onboarding/payment-status",element: <OnboardingPaymentStatus />},
        { path: "payment-cancelled", element: <PaymentCancelled /> }
      ],
    },
    { path: "*", element: <Navigate to="/pagenotfound" replace /> },
  ]);
}
